import { render } from "./ThemeImage.vue?vue&type=template&id=428dce5a"
import script from "./ThemeImage.vue?vue&type=script&lang=js"
export * from "./ThemeImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__